module.exports = __webpack_public_path__ + "img/pt6.f628065c.png";